import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              平台特色
            </h2>
            <p className="text-sm text-foreground-500">为什么选择樱花动漫91？看看我们的核心优势</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {featureItems.map((feature, index) => (
              <div
                key={feature.id}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 text-center group hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${feature.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}